(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["countdown"] && !Shopify.designMode) return;
  try {
    function initCountdown(targetTimestamp) {
    const daysElement = document.getElementById('countdown-days')
    const hoursElement = document.getElementById('countdown-hours')
    const minsElement = document.getElementById('countdown-mins')

    function updateCountdown() {
      const now = new Date().getTime()

      // Parse ISO 8601 date format or Unix timestamp
      let targetTime
      if (
        typeof targetTimestamp === 'string' &&
        targetTimestamp.includes('T')
      ) {
        // ISO 8601 format (e.g., "2025-08-20T08:00:00Z")
        targetTime = new Date(targetTimestamp).getTime()
      } else {
        // Unix timestamp (fallback for backward compatibility)
        targetTime = targetTimestamp * 1000
      }

      const difference = targetTime - now

      if (difference <= 0 || isNaN(targetTime)) {
        // If timestamp is present or past, display 00 for all values
        daysElement.textContent = '00'
        hoursElement.textContent = '00'
        minsElement.textContent = '00'
        return
      }

      // Calculate time remaining
      const days = Math.floor(difference / (1000 * 60 * 60 * 24))
      const hours = Math.floor(
        (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      )
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))

      // Update display with zero-padded values
      daysElement.textContent = days.toString().padStart(2, '0')
      hoursElement.textContent = hours.toString().padStart(2, '0')
      minsElement.textContent = minutes.toString().padStart(2, '0')
    }

    // Update immediately
    updateCountdown()

    // Update every minute
    setInterval(updateCountdown, 30000)
  }

  // Get timestamp from data attribute
  const timestampElement = document.querySelector('[data-countdown-timestamp]')
  let targetTimestamp

  if (timestampElement && timestampElement.dataset.countdownTimestamp) {
    targetTimestamp = timestampElement.dataset.countdownTimestamp

    // Try to parse as ISO 8601 first, then as Unix timestamp
    if (targetTimestamp.includes('T')) {
      // ISO 8601 format - use as string
      targetTimestamp = targetTimestamp
    } else {
      // Assume Unix timestamp - convert to number
      targetTimestamp = parseInt(targetTimestamp)
    }
  } else {
    // Default to 7 days from now in ISO format
    const futureDate = new Date()
    futureDate.setDate(futureDate.getDate() + 7)
    targetTimestamp = futureDate.toISOString()
  }

  // Only initialize if we have a valid timestamp
  if (targetTimestamp) {
    initCountdown(targetTimestamp)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snippet-collapsible-text"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('collapsible-text')) {
    customElements.define(
      'collapsible-text',
      class extends HTMLElement {
        constructor() {
          super()

          this.content = this.querySelector('[data-collapsible-content]')
          this.toggle = this.querySelector('[data-collapsible-toggle]')
        }

        connectedCallback() {
          this.toggle?.addEventListener('click', this.handleClick.bind(this))
        }

        handleClick() {
          if (this.content && this.toggle)
            this.content.setAttribute(
              'data-collapsed',
              this.content?.getAttribute('data-collapsed') === 'true'
                ? 'false'
                : 'true'
            )
        }

        disconnectedCallback() {
          this.toggle?.removeEventListener('click', this.handleClick)
        }
      }
    )
  }
  } catch(e) { console.error(e); }
})();

})();
